import React from 'react';
import { RouteComponentProps } from 'react-router';
import PageLoader from 'components/page-loader';

/**
 * 用户协议
 */
const UserAgreement = PageLoader({
	loader: () => import(/* webpackChunkName: "page-user-agreement" */ './user'),
});

/**
 * 用户隐私协议
 */
const UserPolicy = PageLoader({
	loader: () => import(/* webpackChunkName: "page-user-policy" */ './policy'),
});

/**
 * 隐私保护政策
 */
const Privacy = PageLoader({
	loader: () => import(/* webpackChunkName: "page-privacy" */ './privacy'),
});

/**
 * 个人信息收集清单
 */
const PersonalInfo = PageLoader({
	loader: () => import(/* webpackChunkName: "page-personal-info" */ './personal-info'),
});

/**
 * 第三方共享清单
 */
const ThirdParty = PageLoader({
	loader: () => import(/* webpackChunkName: "page-third-party" */ './third-party'),
});

const PageUserAgreement = (props: RouteComponentProps) => <UserAgreement {...props} />;
const PageUserPolicy = (props: RouteComponentProps) => <UserPolicy {...props} />;
const PagePrivacy = (props: RouteComponentProps) => <Privacy {...props} />;
const PagePersonalInfo = (props: RouteComponentProps) => <PersonalInfo {...props} />;
const PageThirdParty = (props: RouteComponentProps) => <ThirdParty {...props} />;

// 页面入口
export { PageUserAgreement, PageUserPolicy, PagePrivacy, PagePersonalInfo, PageThirdParty };
